import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { APP_BASE_HREF, CommonModule } from '@angular/common';

import { NgCnafCommonsModule } from '@cnaf/ng-cnaf-commons';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { PreparationComponent } from './00-preparation/preparation.component';
import { DeclarationComponent } from './01-declaration/declaration.component';
import { DeclarationEnfantComponent } from './02-declaration-enfant/declaration-enfant.component';
import { FinComponent } from './03-fin/fin.component';
import { SitfamComponent } from './01-declaration/components/sitfam/sitfam.component';
import { InfoLogementComponent } from './01-declaration/components/info-logement/info-logement.component';
import { HttpClientModule }    from '@angular/common/http';
import { PersonnesComponent } from './01-declaration/components/personnes/personnes.component';
import { RessourcesComponent } from './01-declaration/components/ressources/ressources.component';
import { RessourcesEnfantComponent } from './02-declaration-enfant/components/ressources-enfant/ressources-enfant.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SitproComponent } from './01-declaration/components/sitpro/sitpro.component';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { EnfantComponent } from './02-declaration-enfant/components/enfant/enfant.component';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { CcdPageErreurTechniqueComponent } from './components/ccd-page-erreur-technique/ccd-page-erreur-technique.component';
import { PersonneComponent } from './01-declaration/components/personne/personne.component';
import { ModaleCodePostalNonEligibleComponent } from './components/modale-code-postal-non-eligible/modale-code-postal-non-eligible.component';
import { CcdBoutonsRadioComponent, CnafCommonsDralModule  } from '@cnaf.usagers.appli/cnaf-commons-dral';
import { environment } from 'src/environments/environment';
import { BoutonQuitterComponent } from './components/bouton-quitter/bouton-quitter.component';
//import { CnafCommonsAccesServiceAppliModule } from '@cnaf/cnaf-commons-acces-service-appli';

registerLocaleData(localeFr, 'fr');

@NgModule({
  declarations: [
    AppComponent,
    BoutonQuitterComponent,
    PreparationComponent,
    DeclarationComponent,
    DeclarationEnfantComponent,
    FinComponent,
    SitfamComponent,
    InfoLogementComponent,
    SitproComponent,
    PersonnesComponent,
    RessourcesComponent,
    RessourcesEnfantComponent,
    EnfantComponent,
    FinComponent,
    CcdPageErreurTechniqueComponent,
    PersonneComponent,
    ModaleCodePostalNonEligibleComponent
  ],
  imports: [
    CnafCommonsDralModule.forRoot(environment),
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    NgCnafCommonsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    PopoverModule.forRoot(),
    ModalModule.forRoot(),
    TypeaheadModule.forRoot()
    //,
    //CnafCommonsAccesServiceAppliModule
  ],
  providers: [
    {
      provide: APP_BASE_HREF,
      useValue: ''
    }],
  bootstrap: [AppComponent]
})
export class AppModule { }

